import { render, staticRenderFns } from "./UserTrendCell.vue?vue&type=template&id=1edc0069&scoped=true"
import script from "./UserTrendCell.vue?vue&type=script&lang=ts"
export * from "./UserTrendCell.vue?vue&type=script&lang=ts"
import style0 from "./UserTrendCell.vue?vue&type=style&index=0&id=1edc0069&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edc0069",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/user-trend/table/user-trend-cell.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fuser-trend%2Ftable%2FUserTrendCell.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports